export const Palette = {
  black: '#000000',

  gray200: '#F7F7F7',
  gray300: '#EEEEEE',
  gray400: '#D8D8D8',
  gray800: '#1D1D1B',

  primary: '#D7545A',

  white: '#FFFFFF',
};
